import { StyledSettingsSectionTitle } from "./index.styled";

interface SettingsSectionTitleProps {
    title: string;
    subtitle?: string;
    icon: string;
    iconSize?: number;
    uploadButton?: React.ReactNode;
    iconHeight?: number;
}

const SettingsSectionTitle = ({ title, subtitle, icon, iconSize = 15, uploadButton, iconHeight }: SettingsSectionTitleProps) => {
    return (
        <StyledSettingsSectionTitle $hasSubtitle={!!subtitle}>
            <img src={icon} alt={title} style={{ width: iconSize, height: iconHeight || iconSize }} />
            <div className="title-container">
                <h2>{title}</h2>
                {subtitle && <span className="subtitle">{subtitle}</span>}
            </div>
            {uploadButton && <div className="upload-button-container">{uploadButton}</div>}
        </StyledSettingsSectionTitle>
    )
}

export default SettingsSectionTitle;